import { cache } from 'react'

const getInitials: (name: string, count?: number) => string = cache(
    (name: string = '', count = 2) =>
        name
            .split(' ')
            .map((p) => p[0])
            .slice(0, count)
            .join(''),
)

export { getInitials }
